module.exports = __webpack_public_path__ + "img/drinking-coffee.d2e286ff.png";